import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Thanks from './components/Thanks';
import './App.css';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <About />
      <HowItWorks />
      <Contact />
    </>
  );
};

// 404 Redirect Component - redirects unknown paths to home page
const NotFoundRedirect: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to home page for any unknown routes
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
    }
  }, [navigate, location.pathname]);

  return null; // Don't render anything while redirecting
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/thanks" element={<Thanks />} />
            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
